import React from 'react'
import ViewOptionsController from '../UI/ViewOptionsController'

export default function Dashboard() {
  return <ViewOptionsController />
}
